const Seo = () => {
  const normalizedData = {

  }

  return normalizedData
}

export default Seo
